import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const CSS = `
.scalio-footer{position:relative;z-index:1;width:100%;color:#f4f4f5;font-family:'Outfit',system-ui,sans-serif;line-height:1.5;overflow:hidden;}
.scalio-footer,.scalio-footer *{box-sizing:border-box;}
.scalio-footer a{color:inherit;text-decoration:none;}
.scalio-footer p{margin:0;}
.scalio-footer .sf-mega-wrap{padding:40px 0 24px;overflow:hidden;}
.scalio-footer .sf-mega-logo{position:relative;width:min(900px,88vw);margin:0 auto;}
.scalio-footer .sf-mega-img{display:block!important;width:100%!important;max-width:100%!important;height:auto!important;object-fit:contain;filter:drop-shadow(0 20px 60px rgba(44,52,128,.45));}
.scalio-footer .sf-footer{display:flex!important;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:30px;padding:50px 6vw 40px!important;margin:0!important;width:100%!important;border-top:1px solid rgba(255,255,255,.14);background:rgba(0,0,0,.4);}
.scalio-footer .sf-brand{max-width:620px;min-width:0;}
.scalio-footer .sf-logo-link{display:inline-flex;align-items:center;margin-bottom:12px;}
.scalio-footer .sf-logo-img{display:block!important;width:auto!important;height:46px!important;max-width:200px!important;object-fit:contain;}
.scalio-footer .sf-tagline{color:#9a9aa3!important;-webkit-text-fill-color:#9a9aa3!important;font-size:16px;line-height:1.5;}
.scalio-footer .sf-networks{color:#9a9aa3!important;-webkit-text-fill-color:#9a9aa3!important;font-size:13px;line-height:1.5;margin-top:2px;overflow-wrap:anywhere;}
.scalio-footer .sf-links{display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:flex-end;gap:16px 26px;font-size:14px;color:#9a9aa3;}
.scalio-footer .sf-links a{color:#9a9aa3!important;-webkit-text-fill-color:#9a9aa3!important;transition:color .3s;}
.scalio-footer .sf-links a:hover{color:#8f9af0!important;-webkit-text-fill-color:#8f9af0!important;}
.scalio-footer .sf-copy{flex-basis:100%;width:100%;font-size:13px;color:#9a9aa3!important;-webkit-text-fill-color:#9a9aa3!important;}
@media(max-width:900px){.scalio-footer .sf-footer{gap:26px;}.scalio-footer .sf-links{justify-content:flex-start;}}
@media(max-width:600px){.scalio-footer .sf-mega-wrap{padding:30px 0 24px;}.scalio-footer .sf-footer{padding:40px 20px 32px!important;gap:22px;flex-direction:column;}.scalio-footer .sf-logo-img{height:36px!important;max-width:160px!important;}.scalio-footer .sf-links{gap:16px 22px;}.scalio-footer .sf-tagline{font-size:14px;}.scalio-footer .sf-networks{font-size:12px;}}
`;

export default function Footer({ logoSrc = '/scalio-logo.webp' }) {
  const root = useRef(null);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const ctx = gsap.context(() => {
      const logo = root.current.querySelector('.sf-mega-logo');
      gsap.from(logo, { y: 40, opacity: 0, duration: 1.2, ease: 'power3.out',
        scrollTrigger: { trigger: logo, start: 'top 95%' } });
    }, root);
    return () => ctx.revert();
  }, []);
  return (
    <div ref={root} className="scalio-footer">
      <style>{CSS}</style>
      <div className="sf-mega-wrap">
        <div className="sf-mega-logo">
          <img className="sf-mega-img" src={logoSrc} alt="Scalio USDT Card" />
        </div>
      </div>
      <footer className="sf-footer">
        <div className="sf-brand">
          <a className="sf-logo-link" href="#top" aria-label="Scalio USDT Card">
            <img className="sf-logo-img" src={logoSrc} alt="Scalio USDT Card" />
          </a>
          <p className="sf-tagline">Scalio — True Self-Custody Real-Time Spending.</p>
          <p className="sf-networks">Supported Networks: TRON (TRC-20) | Ethereum (ERC-20) | BNB Chain (BEP-20)</p>
        </div>
        <nav className="sf-links" aria-label="Footer">
          <a href="#features">Features</a>
          <a href="#cards">Cards</a>
          <a href="#security">Security</a>
          <a href="#top">Terms of Service</a>
          <a href="#top">Privacy Policy</a>
        </nav>
        <p className="sf-copy">© 2026 Scalio. All rights reserved.</p>
      </footer>
    </div>
  );
}
